import React, { useEffect, useCallback } from 'react'
import QuestionDateComponent from './QuestionDate.component'
import { addLocationToQuestion } from 'pages/Authenticated/Template/views/TemplateEdit/question.utils'
import { useTemplateCreation } from 'pages/Authenticated/Template/views/TemplateEdit/provider/CreateTemplateProvider'
import { generateNewLocationObject } from 'pages/Authenticated/Template/views/TemplateEdit/services'
import { useUser } from 'queries/user/useUser'

const QuestionDate: React.FC = () => {
  const { set, textSelectionIsActive, selectionData, question } = useTemplateCreation()
  const user = useUser()
  const docXmicro = !!user?.beta?.newDocxMicroservice
  const { id, start, end, currentQuestionId: qid, locationId } = selectionData as any

  const addSelectedLocation = useCallback(
    (id: string, start: number, end: number, qid?: string, locId?: string) => {
      set({
        question: addLocationToQuestion(
          question,
          generateNewLocationObject(id, start, end, qid, locId, docXmicro)
        ),
        selectionData: { id: null, start: null, end: null, currentQuestionId: null, locationId: null },
      })
    },
    [set, question, docXmicro]
  )
  const onTextSelectionToggle = (): void => {
    set({ textSelectionIsActive: !textSelectionIsActive })
  }

  useEffect(() => {
    if (start !== null && end !== null && id) {
      addSelectedLocation(id, start, end, qid, locationId)
    }
  }, [id, start, end, qid, locationId, addSelectedLocation])

  return (
    <QuestionDateComponent
      textSelectionIsActive={textSelectionIsActive}
      toggleTextSelection={onTextSelectionToggle}
    />
  )
}

export default QuestionDate
